import React from 'react';

import DesktopSelectedSubGrids from './DesktopSelectedSubGrids';
import MobileSelectedSubGrids from './MobileSelectedSubGrids';
import { useWindowDimensions } from '../../../custom-hooks/useWindowDimensions';

const SelectedSubGrids = () => {
  const { isMobileDevice } = useWindowDimensions();

  return isMobileDevice ? <MobileSelectedSubGrids /> : <DesktopSelectedSubGrids />;
};

export default SelectedSubGrids;
